export default  {	
	data () {
		return { 			
			id_datos_asesor: null,
			mes_periodo: null,
			ano_periodo: null
		}
	},
	async created () { 
		this.mes_periodo = {id: this.fecha().fecha.mesHoy, name: this.gettersDatalist('list_mes',this.fecha().fecha.mesHoy)[0].name}
		this.ano_periodo = {id: this.fecha().fecha.anoHoy, name: this.gettersDatalist('list_ano',this.fecha().fecha.anoHoy)[0].name}
	},
}
